import { createAsyncThunk } from "@reduxjs/toolkit";
import { logoutUser } from "./authThunks";

const API_URL = `${process.env.REACT_APP_API_BASE}/api/payout-requests`;

// GET all payout requests
export const fetchPayoutRequests = createAsyncThunk(
  "payoutRequests/fetchAll",
  async (_, thunkAPI) => {
    try {
      const res = await fetch(API_URL, {
        method: "GET",
        credentials: "include",
        headers: { "Content-Type": "application/json", "x-user-role": "partner" },
      });

      if (res.status === 401) {
        thunkAPI.dispatch(logoutUser());
        const currentUrl = window.location.href;
        const authUrl = `${process.env.REACT_APP_AUTH_BASE_URL}?redirect=${encodeURIComponent(currentUrl)}`;
        window.location.href = authUrl;
        return thunkAPI.rejectWithValue("Unauthorized");
      }

      const json = await res.json();
      if (!res.ok)
        throw new Error(json?.message || "Failed to fetch payout requests");
      return json;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message || "Something went wrong");
    }
  }
);

// GET single payout request by ID
export const fetchPayoutRequestById = createAsyncThunk(
  "payoutRequests/fetchById",
  async (id, thunkAPI) => {
    try {
      const res = await fetch(`${API_URL}/${id}`, {
        method: "GET",
        credentials: "include",
        headers: { "Content-Type": "application/json", "x-user-role": "partner" },
      });

      if (res.status === 401) {
        thunkAPI.dispatch(logoutUser());
        const currentUrl = window.location.href;
        const authUrl = `${process.env.REACT_APP_AUTH_BASE_URL}?redirect=${encodeURIComponent(currentUrl)}`;
        window.location.href = authUrl;
        return thunkAPI.rejectWithValue("Unauthorized");
      }
      const json = await res.json();
      if (!res.ok)
        throw new Error(json?.message || "Failed to fetch payout request");
      return json;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message || "Something went wrong");
    }
  }
);

// POST create a new payout request
export const createPayoutRequest = createAsyncThunk(
  "payoutRequests/create",
  async (payload, thunkAPI) => {
    try {
      const res = await fetch(API_URL, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json", "x-user-role": "partner" },
        body: JSON.stringify(payload),
      });

      if (res.status === 401) {
        thunkAPI.dispatch(logoutUser());
        const currentUrl = window.location.href;
        const authUrl = `${process.env.REACT_APP_AUTH_BASE_URL}?redirect=${encodeURIComponent(currentUrl)}`;
        window.location.href = authUrl;
        return thunkAPI.rejectWithValue("Unauthorized");
      }

      const json = await res.json();
      if (!res.ok)
        throw new Error(json?.message || "Failed to create payout request");
      return json;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message || "Something went wrong");
    }
  }
);

// PUT update a payout request (e.g., mark as donated or pay)
export const updatePayoutRequest = createAsyncThunk(
  "payoutRequests/update",
  async ({ id, data }, thunkAPI) => {
    try {
      const res = await fetch(`${API_URL}/${id}`, {
        method: "PUT",
        credentials: "include",
        headers: { "Content-Type": "application/json", "x-user-role": "partner" },
        body: JSON.stringify(data),
      });

      if (res.status === 401) {
        thunkAPI.dispatch(logoutUser());
        const currentUrl = window.location.href;
        const authUrl = `${process.env.REACT_APP_AUTH_BASE_URL}?redirect=${encodeURIComponent(currentUrl)}`;
        window.location.href = authUrl;
        return thunkAPI.rejectWithValue("Unauthorized");
      }

      const json = await res.json();
      if (!res.ok)
        throw new Error(json?.message || "Failed to update payout request");
      return json;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message || "Something went wrong");
    }
  }
);
